import { render, staticRenderFns } from "./userRegisterHelp.vue?vue&type=template&id=01ad78ca&scoped=true&"
import script from "./userRegisterHelp.vue?vue&type=script&lang=js&"
export * from "./userRegisterHelp.vue?vue&type=script&lang=js&"
import style0 from "./userRegisterHelp.vue?vue&type=style&index=0&id=01ad78ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ad78ca",
  null
  
)

export default component.exports